import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ListItemProps {
  id: number;
  icon: React.ElementType;
  text: string;
  href: string;
  isActive: boolean;
}

const ListItem: React.FC<ListItemProps> = ({
  icon: Icon,
  text,
  href,
  isActive,
}) => {
  const navigate = useNavigate();

  return (
    <li
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginTop: 25,
        cursor: "pointer",
      }}
      onClick={() => {
        navigate(href);
      }}
    >
      <Icon style={{ color: isActive ? "#e991ea" : "#fff" }} />
      <Typography
        variant="caption"
        sx={{
          textAlign: "center",
          color: isActive ? "#e991ea" : "#fff",
          maxWidth: 100,
          mt: 0.5,
        }}
      >
        {text}
      </Typography>
    </li>
  );
};

export default ListItem;
